module.exports = __webpack_public_path__ + "static/right-img1-2fad070e62961e4a5a81d3c9f0db9660.svg";